<div *ngIf="loading" class="spinner-wrapper global-loading">
    <div class="spinner">Loading...</div>
</div>

<header>
    <nav class="navbar">
        <div class="navbar-content">
            <div class="background-container w-100">
                <img src="assets/images/backgrounds/background_header_2.png" class="background-header" alt="monex">
                <div class="user-info-container">
                    <div class="logo-container">
                        <img src="assets/images/icons/monex_login_icon.svg" class="logo-img" alt="monex-icon"><br>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>
<ng-container *ngIf="chargedForm">
    <div *ngIf="isValidToken && showFormOrError">
        <div class="container-fluid">
            <div class="user-name">
                {{ sNameUser }}
            </div>
            <div class="page-content">
                <app-change-password [cveUser]="cveUsuario"
                                     (changePasswordEmit)="savePassword($event)"></app-change-password>
            </div>
        </div>
    </div>
    <div *ngIf="!isValidToken && showFormOrError">
        <div class="container-fluid" style="max-width: max-content; text-align: center;">
            <div class="page-content"
                 style="width: 700px; text-align: center; padding-right: 40px; padding-bottom: 40px;">
                <div class="mt-4 mb-4">
                    <img class="icon" src="assets/images/icons/error-process.png">
                </div>
                <p class="user-name"
                   style="text-align: center;">{{ 'Por cuestiones de seguridad la liga para restablecer tu contraseña ha expirado.' | translate }}</p>
            </div>
        </div>
    </div>
</ng-container>




